import { Controller } from "stimulus"
import $ from 'jquery';

export default class extends Controller {

  connect() {
    this.showElementWhenReady(this.element)
  }

  // Waits 2 secs to show element (prevents autoscroll to embedly on page load)
  showElementWhenReady(targetNode) {
    $(targetNode).css('display', 'none')
    setTimeout(() => {
      $(targetNode).css('display', 'block')
    }, '2000')
  }
}
